import {
  Tooltip,
  Card,
  Typography,
  Select,
  Input,
  Button,
  Switch,
  Pagination,
  Form,
  Empty,
} from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useEffect, useState } from "react";
import SortingArrow from "../../Common/SortingArrow";
import toast from "react-hot-toast";
import globalRequest from "../../utils/global/globalRequest";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import { changeLoader } from "../../redux/reducers/loader";
import {
  checkPermissionAction,
  formatDateFunction,
} from "../../utils/helper/utils";
import config from "../../config";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
import { usePersistentFilters } from "../../Hooks/commonApiHooks/usePersistentFilters";
const selectStatus = [
  {
    value: "",
    label: "All",
  },
  {
    value: "active",
    label: "Active",
  },
  {
    value: "inactive",
    label: "Inactive",
  },
];
let timer = null;
const ProductManagement = () => {
  const [form] = Form.useForm();
  // const searchData = Form.useWatch("search", form);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { Search } = Input;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [allVendor, setAllVendor] = useState([]);

  const [itemData, setItemData] = useState(0);

  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = { status: "deleted" };
      let response = await globalRequest(
        Apis?.MANAGE_PRODUCT?.UPDATE_STATUS + "/" + itemData.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Product deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllProducts();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };
  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const getAllProducts = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_PRODUCT.GET_ALL_PRODUCT,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllProducts();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleStatusChange = async (item) => {
    try {
      let value = { status: item.status === "active" ? "inactive" : "active" };
      let response = await globalRequest(
        Apis?.MANAGE_PRODUCT?.UPDATE_STATUS + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Product active successfully";
        if (item.status === "active") msg = "Product inactive successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllProducts();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllVendor = async () => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_MODIFIERES.GET_ALL_VENDOR_LIST,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (apiResponse.data) {
        apiResponse.data = [
          { id: "", vendorDetail: { storeName: "All" } },
          ...apiResponse.data,
        ];
        let data = apiResponse?.data?.map((item) => {
          return {
            value: item?.id,
            label: item?.vendorDetail?.storeName, //item?.firstName + " " + item.lastName,
          };
        });
        setAllVendor(data);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    getAllVendor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  usePersistentFilters({
    form,
    location,
    currentPath: "/product-management",
    addPath: "/add-product",
    editPathPrefix: "/edit-product/",
    storageKey: "product_filters",
    inputData,
    setInputData,
    paginationModel,
    setPaginationModel,
  });
  const handlFeatureChange = async (item) => {
    try {
      let value = { feature: item.feature === 1 ? 0 : 1 };
      let response = await globalRequest(
        Apis?.MANAGE_PRODUCT?.UPDATE_FEATURE_STATUS + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Product featured successfully";
        if (item.feature) msg = "Product unfeatured successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllProducts();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  return (
    <>
      <Card>
        <div className="block sm:flex justify-between	mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              Product Management
            </Typography>
          </div>
          <div>
            <Select
              style={{
                width: window.innerWidth < 768 ? "100%" : 250,
              }}
              placeholder="Products by vendor name"
              options={allVendor}
              showSearch
              filterOption={(input, allVendor) =>
                (allVendor?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              className="mx-1.5 cursor-pointer my-1 sm:my-0"
              value={form.getFieldValue("vendor_id")}
              onChange={(e) => {
                form.setFieldValue("vendor_id", e);
                setInputData((prev) => ({ ...prev, vendor_id: e }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
            />
            <Select
              style={{
                width: 150,
              }}
              placeholder="Select Status"
              options={selectStatus}
              showSearch
              filterOption={(input, selectStatus) =>
                (selectStatus?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              className="mx-1.5 cursor-pointer my-1 sm:my-0"
              value={form.getFieldValue("status")}
              onChange={(e) => {
                form.setFieldValue("status", e);
                setInputData((prev) => ({ ...prev, status: e }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
            />
            <Search
              placeholder="Search"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "trim");
                form.setFieldValue("search", value);
                setInputData((prev) => ({ ...prev, search: value }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
              style={{
                width: window.innerWidth < 768 ? "100%" : 300,
              }}
              className="mx-1.5 cursor-pointer my-1 sm:my-0"
            />

            {checkPermissionAction(
              "Product Management",
              permissionJson,
              "add"
            ) ? (
              <Button
                type="primary"
                size={14}
                icon={<PlusOutlined />}
                className="mx-1.5 cursor-pointer my-1 sm:my-0"
                onClick={() => navigate("/add-product")}
              >
                Add Product
              </Button>
            ) : null}
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  ID{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("id", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Product Name (EN){" "}
                  <SortingArrow
                    onSort={(order) => handleSort("name_en", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Product Name (AR){" "}
                  <SortingArrow
                    onSort={(order) => handleSort("name_ar", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3">
                  vendor{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("storeName", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Created date & time{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("createdAt", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3">
                  Feature
                </th>
                <th scope="col" className="px-3 py-3">
                  Status
                </th>
                <th
                  scope="col"
                  className="px-3 py-3 text-center whitespace-nowrap vertical-top"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list?.map((item, index) => (
                  <tr className="bg-white border-b" key={index}>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.id || "-"}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        <img
                          src={
                            config.AWS_URL +
                            item?.productUoms[0]?.productUomImages?.find(
                              (locale) => locale.featured === "1"
                            )?.image
                          }
                          alt="cake-img"
                          width={32}
                        />
                        <span>
                          {
                            item?.name_en
                            // item?.productLocales?.find(locale => locale.languageCode === 'en')?.name
                          }
                        </span>
                      </div>
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      {
                        item?.name_ar
                        //item?.productLocales?.find(locale => locale.languageCode === 'ar')?.name
                      }
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      {item?.user.vendorDetail?.storeName}
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      {formatDateFunction(item.createdAt, "dd-mm-yyyy", true)}
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      <Switch
                        checked={item?.feature ? true : false}
                        onChange={() => {
                          handlFeatureChange(item);
                        }}
                      />
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      <Switch
                        checked={item?.status === "active" ? true : false}
                        onChange={() => {
                          handleStatusChange(item);
                        }}
                        disabled={
                          !checkPermissionAction(
                            "Product Management",
                            permissionJson,
                            "update_status"
                          )
                        }
                      />
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap vertical-top">
                      <Tooltip title="Edit">
                        <EditOutlined
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Product Management",
                                permissionJson,
                                "edit"
                              )
                            ) {
                              navigate("/edit-product/" + item.id);
                            }
                          }}
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Product Management",
                              permissionJson,
                              "edit"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                        />
                      </Tooltip>
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Product Management",
                              permissionJson,
                              "delete"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Product Management",
                                permissionJson,
                                "delete"
                              )
                            ) {
                              setIsDeleteModalOpen(true);
                              setItemData(item);
                            }
                          }}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}              
            </tbody>
          </table>
        </div>
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) =>
                setPaginationModel((prev) => ({ ...prev, page: page }))
              }
              onShowSizeChange={(current, size) =>
                setPaginationModel((prev) => ({ ...prev, limit: size }))
              }
            />
          </div>
        ) : null}
      </Card>
      {/* delete modal */}
      <ConfirmationModal
        ConfirmationHeading="Delete"
        ConfirmationParagraph="Are you sure you want to delete this Product?"
        isOpen={isDeleteModalOpen}
        onOk={handleDeleteOk}
        onCancel={handleDeleteCancel}
      />
    </>
  );
};
export default ProductManagement;
